/* eslint-disable max-len */
import { Link } from "@quintype/components";
import { get, hasIn } from "lodash";
import PropType from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { HindiPaywallBanner } from "../../collection-templates/hindi-paywall-banner";
import { checkIfStoryPublic } from "../../../access-type-utils";
// import assetify from "@quintype/framework/assetify";
// import logo from "../../../../assets/images/newslaundry_logo.png";

import "./subscription-appeal.m.css";
import { HindiOfferAppeal } from "./HindiOfferAppeal";

const subscriptionAppeals = [
  {
    name: "ground reports",
    text:
      "This is not an ad. An ad would never fund a story like this. Would you? Pay for free, fair, robust journalism that isn’t influenced by advertisers.",
    hindiText:
      "यह एक विज्ञापन नहीं है. कोई विज्ञापन ऐसी रिपोर्ट को फंड नहीं कर सकता, लेकिन आप कर सकते हैं, क्या आप करेंगे? विज्ञापनदाताओं के दबाव में न आने वाली आज़ाद व ठोस पत्रकारिता के लिए अपना योगदान दें.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-05/7f7922fa-a1a3-474e-9349-fe65ac7b25f7/NL_Subscription_5.png",
  },
  {
    name: "podcasts",
    text:
      "Producing a quality journalism podcast is an expensive enterprise. Subscribe now to help us bring you more award-winning podcasts.",
    hindiText:
      "एक अच्छे स्तर की प्रमाणिक पॉडकास्ट बनाना, परिश्रम के साथ-साथ महंगा काम भी है. हम आपके लिए और कई अवार्ड जीतने वाली और रोचक पॉडकास्ट ला सकें, इसमें हमारा सहयोग करें. न्यूज़लॉन्ड्री को सब्सक्राइब करें.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-06/ad6a561d-1c0c-46a0-8397-0d29f861afda/show.png",
  },
  {
    name: "stories on media acquisitions",
    text:
      "Supporting independent media has never been more important. We need you to step up. For we depend on you for support, not on government or corporate advertisers.",
    hindiText:
      "स्वतंत्र मीडिया का समर्थन और सहयोग करना आज बहुत जरूरी हो गया है. हमें आपके सहयोग की जरूरत है. क्योंकि हम सरकारों या कॉरपोरेट विज्ञापन दाताओं के सहयोग पर नहीं, बल्कि आपके सहयोग पर निर्भर हैं.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png",
  },
  {
    name: "independent media",
    text:
      "The media must be free and fair, uninfluenced by corporate or state interests. That's why you, the public, need to pay to keep news free.",
    hindiText:
      "मीडिया को कॉरपोरेट या सत्ता के हितों से अप्रभावित, आजाद और निष्पक्ष होना चाहिए. इसीलिए आपको, हमारी जनता को, पत्रकारिता को आजाद रखने के लिए खर्च करने की आवश्यकता है. आज ही सब्सक्राइब करें.",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-08/938f8262-4fed-42ba-a67f-e63ab4b261ec/NL_Subscription_1_copy.png",
  },
  {
    name: "so sketchy",
    text:
      "We want to revive the fading tradition of political commentary through cartoon, a medium that today more than ever needs to be rewarded and not censored. So Sketchy is a step in that direction. We want to do much more. We are counting on your support.",
    hindiText: "",
    imageURL:
      "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png",
  },
];

const pressFreedomText = {
  // heading: "Monu Manesar’s video profile",
  heading: "📽️ The making of Monu Manesar",
  hindiHeading: "📽️ मोनू मानेसर एंड गैंग",
  text: (
    <div styleName="appeal-text-div">
      <span>
        Monu Manesar is back in the news as a key figure in the Haryana
        violence. But what do we know about him? Does the state back him? Who
        are his mentors?
      </span>
      <span>
        Newslaundry has exclusive footage, a fly-on-the-wall account of the
        actions of Monu and his gang. The short film has been made by
        independent filmmakers, who trailed Monu and his accomplices for weeks
        between late 2021 and early 2022.
      </span>
      <span>
        <b>
          Help us recover the costs accured in the making of this film.
          Contribute now.
        </b>
      </span>
    </div>
  ),
  hindiText: (
    <div styleName="appeal-text-div">
      <span>
        मोनू मानेसर एक बार फिर से सुर्खियों में है. इस बार उसके सुर्खियों में
        आने की वजह है हरियाणा के विभिन्न इलाकों में हुई हिंसा. कुछ ही महीनों
        पहले दो मुस्लिम युवकों नासिर और जुनैद की जलाकर की गई हत्या के बाद मोनू
        के खिलाफ पुलिस ने कोई सख्त कार्रवाई नहीं की. इस कारण नूंह जिले के
        मुस्लिमों में भारी गुस्सा है.
      </span>
      <span>
        दो-दो राज्यों की पुलिस द्वारा वांछित अपराधी होने के बावजूद मोनू लगातार
        टीवी चैनलों पर इंटरव्यू दे रहा है. वहीं, हरियाणा और राजस्थान दोनों ही
        राज्य मोनू के खिलाफ कोई कार्रवाई न होने के लिए एक दूसरे पर
        आरोप-प्रत्यारोप की राजनीति कर रहे हैं.
      </span>
      <span>
        न्यूज़लॉन्ड्री ने इस तथाकथित गौरक्षक मोनू मानेसर और उसके गैंग, इनके
        इन्फॉर्मर्स, जीपीएस डिवाइस, मोडिफाइड गाड़ी और इनकी हौसला अफजाई करने वाले
        पूरे तंत्र को कैमरे में दर्जकिया है. इनके आका कौन हैं? कैसे ये पूरा
        तंत्र काम करता है और क्या सरकार से भी इन्हें मदद मिलती है?
      </span>
      <span>
        इन सब सवालों के जवाब जल्द ही रिलीज़ होने वाली इस छोटी सी वीडियो फिल्म
        में है. इसे कुछ स्वतंत्र फिल्मकारों ने बनाया है. ये लोग साल 2021 के
        अंतिम दिनों से लेकर 2022 की शुरुआत तक मोनू मानेसर और उसके साथियों की
        गतिविधियों को कैमरे की निगाह से दर्ज कर रहे थे.
      </span>
    </div>
  ),
  ctaText: "Contribute now",
  ctaHindiText: "योगदान दें",
  imageURL:
    "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png",
  ctaURL: "/nl-sena/monu-manesars-video-profile?ref=subscription-appeal-banner",
};

const SubscriptionAppealCTA = ({ element, subAppeal, isPressFreedom, story }) => {
  const [isHindi, setIsHindi] = React.useState(false);
  const isStoryPublic = checkIfStoryPublic(story);

  const member = useSelector((state) => {
    return get(state, ["member"], null);
  });
  const hasActiveSubscription = useSelector((state) =>
  get(state, ["fetchSubscription", "isActive"], null)
);
  React.useEffect(() => {
    setIsHindi(global.location.host.includes("hindi."));
  }, []);

  const ctaTitle = get(element, ["metadata", "cta-title"], "");
  const ctaURL = get(element, ["metadata", "cta-url"], "");

  let derivedCTAURL = "";
  let selectedSubscriptionAppeal = null;

  if (ctaURL) {
    derivedCTAURL = ctaURL.split("https://www.newslaundry.com")[1];
  }

  if (subAppeal) {
    selectedSubscriptionAppeal = subscriptionAppeals.find(
      (appeal) => appeal.name === subAppeal
    );
  }

  const DescriptionText = () => {
    return (
      <span>
        {(selectedSubscriptionAppeal &&
          (isHindi
            ? selectedSubscriptionAppeal.hindiText
            : selectedSubscriptionAppeal.text)) ||
          ctaTitle}
      </span>
    );
  };

  if (isPressFreedom) {
    if (!isHindi) {
        return (
    <div styleName="div-container">
      <div styleName="wrapper" className="full-width-with-padding">
        <div styleName="left-container">
          <img
            src= "https://images.assettype.com/newslaundry/2023-10/11139650-deef-4da6-ace5-048535437a8d/joint_subscription_png.png"
            alt="subscription-appeal-image"
            styleName="subscription-appeal-image"
          />
        </div>
        <div styleName="middle-container">
          <div styleName="row-wrapper">
            <h1 styleName="text-container">
              <span>The NL-TNM Election Fund</span>
            </h1>
          </div>
          <div styleName="appeal-wrapper">
            <p styleName="appeal-text">
            We are joining hands with <i>The News Minute</i> for the upcoming assembly elections in five states. Over the last ten years, you, our readers, have made ground reportage possible. It’s now more important than ever to have facts from the ground. Help us get boots on the ground that will bring you reports, interviews and shows.
            </p>
            <Link
              href="/electionfund"
              styleName="pay-btn"
            >
              Contribute Now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );



      // below is Monu Manesar appeal
      // return (
      //   <div styleName="div-container" style={{ display: "none" }}>
      //     {/* Remove display none to show CTA */}
      //     <div styleName="wrapper-pf" className="full-width">
      //       {/* <div styleName="left-container">
      //       <img
      //         src={
      //           (selectedSubscriptionAppeal &&
      //             selectedSubscriptionAppeal.imageURL) ||
      //           // "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png"
      //           "https://images.assettype.com/newslaundry/2023-08/2f311648-5bc4-4a41-b1ad-a92a8af142b8/coming_soon.jpg"
      //         }
      //         alt="subscription-appeal-image"
      //         styleName="subscription-appeal-image"
      //       />
      //     </div> */}
      //       <div styleName="middle-container">
      //         <div styleName="row-wrapper">
      //           <h1 styleName="text-container">
      //             <span>
      //               {/* {isHindi
      //               ? pressFreedomText.hindiHeading
      //               : pressFreedomText.heading} */}
      //               {pressFreedomText.heading}
      //             </span>
      //           </h1>
      //         </div>
      //         <div styleName="appeal-wrapper">
      //           {/* {isPressFreedom ? (
      //           isHindi ? (
      //             pressFreedomText.hindiText
      //           ) : (
      //             pressFreedomText.text
      //           )
      //         ) : (
      //           <p styleName="appeal-text">
      //             <DescriptionText />
      //           </p>
      //         )} */}
      //           {pressFreedomText.text}
      //           <Link
      //             href={
      //               isPressFreedom
      //                 ? pressFreedomText.ctaURL
      //                 : derivedCTAURL ||
      //                   "/subscription?ref=subscription-appeal-banner"
      //             }
      //             styleName="pay-btn"
      //           >
      //             {isHindi
      //               ? pressFreedomText.ctaHindiText
      //               : pressFreedomText.ctaText}
      //           </Link>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // );
    } else if(member && hasActiveSubscription) {
      return (
      <HindiOfferAppeal/>
      );
    }
  else if(isStoryPublic) {
      return (
        <>
          {/* <HindiPaywallBanner /> */}
          <HindiOfferAppeal/>
        </>
      );
    }
  }

  return null;

  // return (
  //   <div styleName="div-container">
  //     <div styleName="wrapper" className="full-width">
  //       <div styleName="left-container">
  //         <img
  //           src={
  //             (selectedSubscriptionAppeal &&
  //               selectedSubscriptionAppeal.imageURL) ||
  //             "https://images.assettype.com/newslaundry/2022-08/fb9ec400-b15f-4aee-8c58-0a15d19d147b/NL_HOMEPAGE_1_copy.png"
  //           }
  //           alt="subscription-appeal-image"
  //           styleName="subscription-appeal-image"
  //         />
  //       </div>
  //       <div styleName="middle-container">
  //         <div styleName="row-wrapper">
  //           <h1 styleName="text-container">
  //             <span>Support Independent Media</span>
  //           </h1>
  //         </div>
  //         <div styleName="appeal-wrapper">
  //           <p styleName="appeal-text">
  //             <DescriptionText />
  //           </p>
  //           <Link
  //             href={
  //               isPressFreedom
  //                 ? pressFreedomText.ctaURL
  //                 : derivedCTAURL ||
  //                   "/subscription?ref=subscription-appeal-banner"
  //             }
  //             styleName="pay-btn"
  //           >
  //             Subscribe Now
  //           </Link>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
};

SubscriptionAppealCTA.propTypes = {
  element: PropType.object,
  subAppeal: PropType.string,
  isHindi: PropType.bool,
  isPressFreedom: PropType.bool,
};

export { SubscriptionAppealCTA };
